export default "__VITE_ASSET__BZB5wIDy__"